import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'zh' : import.meta.env.VITE_APP_LANG);

export const getDevToken = () =>
  `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc2NDc1ODU1MDQ3MSwiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTA2MDI4In0.N6wRG-CzH11WP3hvqrAW15u7FEDmENDS7ks_lvfgn3_xxkru6v5XW0s9Ml1LR-_6BTVxf3j_ErQLE4BuVore5Q`;

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';
